// eslint-disable-next-line import/prefer-default-export
export const GET_TRAININGS_BY_SUPPLIER = `
    trainingInfo: trainings(locale :"$lang", supplier_id :"$supplier_id") {
        training_name
        description
        media_link
        video_id
        featured_image
        cta_external_link
  }
`

// eslint-disable-next-line import/prefer-default-export
export const GET_TRAININGS = `
    trainingInfo: trainings(locale :"$lang") {
        training_name
        description
        media_link
        video_id
        featured_image
        cta_external_link
  }
`

// eslint-disable-next-line import/prefer-default-export
export const GET_ALL_SUPPLIERS = `
    allSuppliers: suppliers(locale :"$lang") {
        entity_id
        supplier_name
        description
        website_url
        supplier_logo
  }
`
